class CartSampleNotifications {
  constructor() {
    this.init();
  }

  init() {
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupCartMonitoring());
    } else {
      this.setupCartMonitoring();
    }
  }

  setupCartMonitoring() {
    // Monitor cart changes
    this.updateProductSampleAttributes();
    
    // Listen for cart updates
    document.addEventListener('cart:updated', () => {
      this.updateProductSampleAttributes();
    });

    // Listen for quantity changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('[name*="updates"]') || e.target.matches('.quantity__input')) {
        setTimeout(() => this.updateProductSampleAttributes(), 100);
      }
    });
  }

  async updateProductSampleAttributes() {
    try {
      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Check for products that need sample notifications
      const productSampleInfo = this.analyzeCartForSamples(cart);
      
      if (productSampleInfo.hasProductSamples) {
        await this.updateCartWithProductSampleInfo(productSampleInfo);
      }
    } catch (error) {
      console.error('Error updating product sample attributes:', error);
    }
  }

  analyzeCartForSamples(cart) {
    const productSampleInfo = {
      hasProductSamples: false,
      sampleProducts: [],
      instructionLines: [],
      summaryParts: []
    };

    // Get sample text settings from the page
    const sampleSettings = this.getSampleSettings();
    
    if (!sampleSettings.enabled || !sampleSettings.template) {
      return productSampleInfo;
    }

    // Check each cart item
    cart.items.forEach(item => {
      // Check if this product should have a sample
      if (this.shouldProductHaveSample(item, sampleSettings)) {
        productSampleInfo.hasProductSamples = true;
        productSampleInfo.sampleProducts.push({
          id: item.product_id,
          title: item.product_title,
          variant_id: item.variant_id,
          quantity: item.quantity,
          sample_text: sampleSettings.template.replace('PRODUCT_NAME', item.product_title)
        });
        
        const sampleText = sampleSettings.template.replace('PRODUCT_NAME', item.product_title);
        productSampleInfo.instructionLines.push(`• ${sampleText}`);
        productSampleInfo.summaryParts.push(`${item.product_title} × ${item.quantity}`);
      }
    });

    return productSampleInfo;
  }

  getSampleSettings() {
    // Try to get settings from the cart page section
    const cartSection = document.querySelector('[data-section-type="main-cart-items"]');
    if (!cartSection) {
      return { enabled: false, template: '' };
    }

    // Look for sample text in the DOM to determine if it's enabled
    const sampleTextElement = document.querySelector('.cart-item__sample-text');
    if (!sampleTextElement) {
      return { enabled: false, template: '' };
    }

    // Extract the template from the sample text
    const sampleText = sampleTextElement.textContent.trim();
    const productName = sampleTextElement.closest('.cart-item').querySelector('.cart-item__name').textContent.trim();
    const template = sampleText.replace(productName, 'PRODUCT_NAME');

    return {
      enabled: true,
      template: template
    };
  }

  shouldProductHaveSample(item, sampleSettings) {
    // For now, assume all products with the sample setting enabled should have samples
    // This can be extended to check product-specific settings if needed
    return sampleSettings.enabled && item.quantity > 0;
  }

  async updateCartWithProductSampleInfo(productSampleInfo) {
    try {
      const instructions = productSampleInfo.instructionLines.length > 0
        ? `Automatic product samples:\n${productSampleInfo.instructionLines.join('\n')}`
        : '';

      const summary = productSampleInfo.summaryParts.length > 0
        ? productSampleInfo.summaryParts.join('; ')
        : '';

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            '_product_sample_data': null,
            '_product_sample_count': null,
            '_product_sample_instructions': null,
            '_product_sample_summary': null
          }
        })
      });

      if (!response.ok) {
        console.error('Failed to update cart with product sample info');
      }
    } catch (error) {
      console.error('Error updating cart with product sample info:', error);
    }
  }
}

// Initialize the cart sample notifications system
new CartSampleNotifications();
